<div class="action" (click)="setActive($event)" [ngClass]="{'active': active, 'locked': conflict}"
     (clickOutside)="resetActive()">
    <div class="action-label-title" *ngIf="label">
        {{label}}
    </div>
    <div class="action-media">
        <ng-content class="action-media-object" select="fui-icon"></ng-content>
    </div>
    <div class="action-modal" *ngIf="title">
        <div class="action-modal-window">
            <div class="action-modal-window-content" id="label">
                {{title | translate}}
            </div>
        </div>
    </div>
</div>
<div class="modal" *ngIf="active" [@fade] [style.max-height]="'calc(100vh - ' + mainTopPosition + ')'">
    <div class="modal-window">
        <div class="modal-window-main">
            <ng-content></ng-content>
        </div>
    </div>
</div>
